import { useClientTranslations } from "../../lib/i18n/client";
import styles from "./ProviderList.module.css";

interface Provider {
	id: string;
	name: string;
	specialty: string;
	image?: string;
	isYourProvider?: boolean;
	rating?: number;
	nextAvailable?: string;
}

interface ProviderListProps {
	providers: Provider[];
	onSelectProvider: (provider: Provider) => void;
}

export function ProviderList({
	providers,
	onSelectProvider,
}: ProviderListProps) {
	const { t } = useClientTranslations("consultExpert");

	return (
		<div className={styles.grid}>
			{providers.map((provider) => (
				<button
					key={provider.id}
					type="button"
					className={styles.card}
					onClick={() => onSelectProvider(provider)}
				>
					{/* Provider Header */}
					<div className={styles.cardContent}>
						<div className={styles.header}>
							<div className={styles.avatar}>
								{provider.image ? (
									<img
										src={provider.image}
										alt={provider.name}
										className={styles.avatarImage}
									/>
								) : (
									<div className={styles.avatarPlaceholder}>
										<svg
											className={styles.avatarIcon}
											fill="currentColor"
											viewBox="0 0 24 24"
											aria-label="Provider avatar"
										>
											<title>Provider avatar</title>
											<path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
										</svg>
									</div>
								)}
							</div>
							<div className={styles.info}>
								<h3 className={styles.name}>{provider.name}</h3>
								<p className={styles.specialty}>{provider.specialty}</p>
								{provider.rating && (
									<div className={styles.rating}>
										<span className={styles.star}>★</span>
										<span className={styles.ratingText}>
											{provider.rating.toFixed(1)}
										</span>
									</div>
								)}
							</div>
						</div>

						{/* Provider Info */}
						<div className={styles.details}>
							<div className={styles.detailItem}>
								<span className={styles.icon}>📹</span>
								<span className={styles.detailText}>
									{t("providerCard.videoConsultation")}
								</span>
							</div>
							<div className={styles.detailItem}>
								<span className={styles.icon}>🕐</span>
								<span className={styles.detailText}>
									{t("providerCard.sessionDuration")}
								</span>
							</div>
							{provider.nextAvailable && (
								<div className={styles.detailItem}>
									<span className={styles.icon}>📅</span>
									<span className={styles.detailTextHighlight}>
										{t("providerCard.nextAvailable")} {provider.nextAvailable}
									</span>
								</div>
							)}
						</div>
					</div>

					{/* Action Button */}
					<div className={styles.footer}>
						<div className={styles.button}>
							<span>{t("providerCard.viewAvailability")}</span>
							<span className={styles.arrow}>→</span>
						</div>
					</div>
				</button>
			))}
		</div>
	);
}
